import { ReactNode } from "react";
import styled from "styled-components";

const CardWrapper = styled.div<{ color: string }>`
  width: 100%;
  padding: 1rem;
  border-right: 0.5rem solid ${({ color }) => color};
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.bg.prim_500};

  .l-info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    h3 {
      font-weight: 400;
      font-size: 1rem;
      /* color: ${({ color }) => color}; */
    }

    h2 {
      font-size: 1.1rem;
      font-weight: bold;
      span {
        font-size: 0.85rem;
        color: ${({ theme }) => theme.text.prim_200};
        font-weight: 400;
      }
    }
  }
`;

export interface ICardStatProps {
  icon: ReactNode;
  value: number;
  title: string;
  color: string;
  description?: string;
}

export function StatsCard({
  icon,
  title,
  color,
  value,
  description,
}: ICardStatProps) {
  return (
    <CardWrapper color={color}>
      <div className="l-info">
        {icon}
        <h3>{title}</h3>
        <h2>
          {value} {description && <span>({description})</span>}
        </h2>
      </div>
    </CardWrapper>
  );
}
